import { HUNDRED, NUMBER_OF_DAYS_IN_WEEK } from "../../App";
import { Page, Publication } from "../types/dataTypes";

/**
 * Calculates the percentage of the total doc visits that visited a page
 *
 * @param {number} uniquePageviewCount amount of times a certain page was visited
 * @param {number} totalDocVisits The amount of visits the publication has in total
 * @returns {number} the percentage of visitors
 *
 */
export const getPercentageOfVisitors = (uniquePageviewCount: number,
	totalDocVisits: number): any => {
	return ((uniquePageviewCount / totalDocVisits) * HUNDRED);
};
/**
 * Calculates the labels and user flow over time and puts them in labels and a dataset.
 *
 * @param {Object} pages the pages you want to extract data from
 * @param {number} totalDocVisits The amount of visits the publication has in total
 * @param {function} setLoaded check if done
 * @return {Object} including labels and datasets
 *
 */
export const getUserFlowData = (pages: Page[], totalDocVisits: number, setLoaded: any): any => {
	let pageNumber = 1;
	const labels = pages.map(page => pageNumber++);
	const percentageOfVisitorsPerPage: number[] = [];

	pages.forEach((page) => {
		percentageOfVisitorsPerPage.push(getPercentageOfVisitors(page.uniquePageViewCount,
			totalDocVisits));
	});

	const datasets = [{
		label: "Linear User Flow",
		backgroundColor: "#00B1FF",
		borderColor: "#0098FF",
		borderWidth: 3,
		data: percentageOfVisitorsPerPage
	}];

	setLoaded(true);
	return { labels, datasets };
};

export const setPublicationDataCorrect = (publication: Publication,
	publicationTotalPages: number, setLoaded: any): any => {
	const data = publication.data;
	const session = data.Publication.Sessions;
	const visitors = data.Publication.Visitors;
	const visitorsOverTime = data.Publication.VisitorsOverTime.map((v: any) => {
		return { visitorCount: v.visitorCount, timestamp: v.timestamp, timeUnit: v.timeUnit };
	});

	while (visitorsOverTime.length > NUMBER_OF_DAYS_IN_WEEK)
		visitorsOverTime.shift();

	publication.data = {
		uniqueVisitors: visitors.newVisitorCount,
		averageSessionDuration: session.avgSessionDuration,
		averagePageViewPerSession: session.avgPageviewsPerSessionCount,
		docVisits: session.sessionCount,
		totalVisitors: visitorsOverTime,
		totalPages: publicationTotalPages
	};

	setLoaded(true);
	return ;
};